<template>
    <div class="card card-body">
        <h2>Beliebte Produktkategorien</h2>
        <apexchart width="420" type="donut" :options="options" :series="series"/>
    </div>
</template>

<script>
export default {
    props: {
        categories: Array,
    },

    data() {
        return {
            highlight: 5,
            options: {
                colors: ['#9881F6', '#a28ff1', '#b1a2ec', '#c3b7f1', '#c3b7f1', '#ccc'],
                labels: [],
            },
        }
    },

    beforeMount() {
        let out = []
        for (let categoryWithImpression of this.categories.slice(0, this.highlight)) {
            out.push(categoryWithImpression.category)
        }
        if (this.categories.length > this.highlight) {
            out.push('Andere')
        }
        this.options.labels = out
    },

    computed: {
        otherImpressions() {
            return this.categories.slice(this.highlight).
                reduce((previousValue, current) => previousValue + current.impressions, 0)
        },

        series() {
            let out = []
            for (let categoryWithImpression of this.categories.slice(0, this.highlight)) {
                out.push(categoryWithImpression.impressions)
            }
            if (this.categories.length > this.highlight) {
                out.push(this.otherImpressions)
            }
            return out
        },
    },
}
</script>
